import { Box, Flex } from '@chakra-ui/react'
import Divider from '../Divider'
import { Button } from '@morressier/alembic'

const SubmitButton = ({ isLoading, buttonText = 'Continue', margin }: {
  isLoading: boolean;
  buttonText?: string;
  margin?: number
}) => {
  return (
    <>
      <Box mt={6}>
        {Divider}
      </Box>
      <Flex justifyContent={{ base: 'stretch', md: 'flex-end' }} m={margin ? margin : 4}>
        <Button variant="primary" type="submit" disabled={isLoading} width={{ base: '100%', md: 'auto' }}>
          {buttonText}
        </Button>
      </Flex>
    </>
  )
}

export default SubmitButton
